<template>
  <h2 class="heading-2 mb-16 flex-1 md:mb-0">
    {{ numberOfOrders }}
  </h2>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'

import type { Preset } from '../../Tab.types'

import translations from './ResultsCounters.translations'

const props = defineProps<{ count: number; preset: Preset }>()

const i18n = useI18n()

const numberOfOrders = computed(() => {
  const presetTranslations = {
    new: translations.newOrdersNumber,
    pending: translations.pendingOrdersNumber,
    'needing-response': translations.needingResponseOrdersNumber,
    all: translations.allOrdersNumber,
  }

  const translationKey = presetTranslations[props.preset]

  return i18n(translationKey, {
    orderCount: props.count,
  })
})
</script>
